import { Route } from 'react-router-dom';

import * as components from './components';

// 触达相关页面路由
const reachRoutes = [
  { path: 'notifications', element: 'Notifications' },
  { path: 'user-feedback', element: 'UserFeedback' },
  { path: 'unsubscribe', element: 'Unsubscribe' },
  { path: 'notifications-setting', element: 'NotificationsSetting' },
];

export default reachRoutes.map(({ path, element }) => {
  const Component = components[element as keyof typeof components];

  return <Route key={path} path={path} element={<Component />} />;
});
